import CloseIcon from '@mui/icons-material/Close';
import { Drawer, Typography, IconButton, Button, Box } from '@mui/material';
import { DrawerContent } from 'shared/ui/Drawer/DrawerStyles';
import { useDeleteParticipantFromCompetitionMutation } from 'entities/competitions-b2cr';

type Props = {
  isShow: boolean;
  setIsShow: React.Dispatch<React.SetStateAction<boolean>>;
  competitionId: number;
  removeCompetitionParticipantId: number;
  refetchParticipants: () => void;
};

export const CompetitionParticipantDeleteDrawer = ({
  competitionId,
  removeCompetitionParticipantId,
  isShow,
  setIsShow,
  refetchParticipants,
}: Props) => {
  const [deleteParticipant] = useDeleteParticipantFromCompetitionMutation();

  const handleSubmit = () => {
    deleteParticipant({
      competitionId,
      participantId: removeCompetitionParticipantId,
    }).then(() => {
      refetchParticipants();
      setIsShow(false);
    });
  };
  return (
    <Drawer
      anchor="right"
      open={isShow}
      onClose={() => setIsShow(false)}
    >
      <DrawerContent>
        <div className="header">
          <Typography
            variant="h5"
            sx={{ fontWeight: '600' }}
          >
            Удалить участника
          </Typography>
          <IconButton
            onClick={() => setIsShow(false)}
            sx={{ color: '#000' }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <div className="content">
          <div>
            <div style={{ marginBottom: '20px' }}>Вы действительно хотите удалить участника?</div>
          </div>

          <Box
            sx={{
              display: 'flex',
              marginTop: '30px',
            }}
          >
            <Button
              color="error"
              variant="contained"
              sx={{ textTransform: 'none' }}
              onClick={handleSubmit}
            >
              Да, удалить
            </Button>
          </Box>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
